/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_search_filter_empty17 = /** @type {(inputs: {}) => string} */ () => {
	return `No corresponding filter`
};

const fr_search_filter_empty17 = /** @type {(inputs: {}) => string} */ () => {
	return `Aucun filtre correspondant`
};

const de_search_filter_empty17 = /** @type {(inputs: {}) => string} */ () => {
	return `Kein entsprechender Filter`
};

const es_search_filter_empty17 = /** @type {(inputs: {}) => string} */ () => {
	return `No hay filtro correspondiente`
};

const it_search_filter_empty17 = /** @type {(inputs: {}) => string} */ () => {
	return `Nessun filtro corrispondente`
};

const ar_search_filter_empty17 = /** @type {(inputs: {}) => string} */ () => {
	return `لا يوجد مرشح مماثل`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const search_filter_empty17 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_filter_empty17(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search_filter_empty17", locale)
	if (locale === "en") return en_search_filter_empty17(inputs)
	if (locale === "fr") return fr_search_filter_empty17(inputs)
	if (locale === "de") return de_search_filter_empty17(inputs)
	if (locale === "es") return es_search_filter_empty17(inputs)
	if (locale === "it") return it_search_filter_empty17(inputs)
	return ar_search_filter_empty17(inputs)
};
export { search_filter_empty17 as "SEARCH_FILTER_EMPTY" }